import React, { useState } from "react";
import BreadCrumbs from "../../../../components/BreadCrumbs";
import PillNavigation from "../../../../components/SubNavBar";
import { Card, CardBody } from "react-bootstrap";
import { TabContent, TabPane } from "reactstrap";
import { NAV_LIST_MENU_ITEM } from "../../../../dummyData/FoodItemData";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ButtonComponent from "../../../../components/ButtonComponent";
import AllMenuItems from "./AllItems";
import CuztomizeMenuItems from "./CuztomizeMenuItems";
import SellableSKU from "./SellableSKU";
import ArchivedItems from "./ArchivedItems";

const ItemTable = () => {
  const navigate = useNavigate();

  const [active, setActive] = useState(1);

  const toggle = (tab: any) => {
    setActive(tab);
  };
  const restaurantStatus = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails?.status
  );

  const handleAddNewMenuItem = () => {
    if (restaurantStatus === "Pending") {
      toast.warning(
        "Your restauarnt is still pending. Pending Untill it get approved"
      );
    } else {
      navigate("/productCatalogue/stock-keeping-unit/add-product");
    }
  };
  return (
    <>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <div className="d-flex justify-content-end w-100">
        <ButtonComponent titel="Add" onClick={handleAddNewMenuItem} />
      </div>
      <Card>
        <CardBody>
          <PillNavigation
            navList={NAV_LIST_MENU_ITEM}
            active={active}
            toggle={toggle}
          />
          <TabContent className="py-50" activeTab={active}>
            {active === 1 && (
              <div className="subnavbareachpart">
                <TabPane tabId={1}>
                  <AllMenuItems />
                </TabPane>
              </div>
            )}
            {active === 2 && (
              <div className="subnavbareachpart">
                <TabPane tabId={2}>
                  <SellableSKU />
                </TabPane>
              </div>
            )}
            {active === 3 && (
              <div className="subnavbareachpart">
                <TabPane tabId={3}>
                  <CuztomizeMenuItems />
                </TabPane>
              </div>
            )}
            {active === 4 && (
              <div className="subnavbareachpart">
                <TabPane tabId={4}>
                  <ArchivedItems />
                </TabPane>
              </div>
            )}
          </TabContent>
        </CardBody>
      </Card>
    </>
  );
};

export default ItemTable;
